import type { FunctionComponent } from 'react'

import styles from './article-paragraph.module.scss'
import { Heading } from '@components/heading'
import { Markdown } from '@components/markdown'
import type { MarkdownFragment } from '@graphql/fragments/MarkdownFragment.graphql'

/**
 * Displays a paragraph with title, has markdown support.
 */
export const ArticleParagraph: FunctionComponent<MarkdownFragment> = ({
    anchor,
    title,
    body,
}) => (
    <div className={styles.section}>
        <Heading level={2} anchor={anchor}>
            {title}
        </Heading>
        {body && <Markdown markdown={body} />}
    </div>
)
